if (!customElements.get("recipient-form")) {
  customElements.define(
    "recipient-form",
    class RecipientForm extends HTMLElement {
      constructor() {
        super();

        this.recipientFieldsLiveRegion = this.querySelector(
          `#Recipient-fields-live-region-${this.sectionId}`
        );

        this.checkboxInput = this.querySelector(
          `#Recipient-checkbox-${this.sectionId}`
        );
        this.checkboxInput.disabled = false;

        this.hiddenControlField = this.querySelector(
          `#Recipient-control-${this.sectionId}`
        );
        this.hiddenControlField.disabled = true;

        this.fieldsContainer = this.querySelector(`#Recipient-fields-${this.sectionId}`);

        this.emailInput = this.querySelector(`#Recipient-email-${this.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.sectionId}`);

        this.offsetProperty = this.querySelector(
          `#Recipient-timezone-offset-${this.sectionId}`
        );
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessage = this.querySelector(
          ".recipient-form__error-message-wrapper"
        );
        this.errorMessageList = this.errorMessage?.querySelector("ul");

        this._currentProductVariantId = this.getAttribute(
          "data-product-variant-id"
        );

        this.addEventListener("change", this.onChange.bind(this));
        this.onChange();
      }

      get sectionId() {
        return this.getAttribute("data-section-id");
      }

      get currentProductVariantId() {
        return this._currentProductVariantId;
      }

      set currentProductVariantId(val) {
        this._currentProductVariantId = val;
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;
      variantChangeHandler = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          (event) => {
            if (
              event.source === "product-form" &&
              event.productVariantId.toString() === this.currentProductVariantId
            ) {
              this.resetRecipientForm();
            }
          }
        );

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            if (event.data.sectionId === this.sectionId) {
              this.currentProductVariantId = event.data.variant.id.toString();
            }
          }
        );

        this.cartErrorUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartError,
          (event) => {
            if (
              event.source === "product-form" &&
              event.productVariantId.toString() === this.currentProductVariantId
            ) {
              this.displayErrorMessage(event.message, event.errors);
            }
          }
        );

        // Custom variant change handler
        const productFormElement = this.closest("form");
        if (productFormElement) {
          this.variantChangeHandler = (event) => {
            const { variant } = event.detail;
            this.currentProductVariantId = variant.id.toString();
          };
          productFormElement.addEventListener(
            "variant:change",
            this.variantChangeHandler
          );
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
        if (this.cartErrorUnsubscriber) this.cartErrorUnsubscriber();

        // Custom variant change handler
        if (this.variantChangeHandler) {
          const productFormElement = this.closest("form");
          productFormElement?.removeEventListener("variant:change", this.variantChangeHandler);
        }
      }

      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText = window.theme.strings.accessibility.recipientFormExpanded;
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText = window.theme.strings.accessibility.recipientFormCollapsed;
        }

        this.fieldsContainer.classList.toggle("hidden", !this.checkboxInput.checked);
      }

      inputFields() {
        return [
          this.emailInput,
          this.nameInput,
          this.messageInput,
          this.sendonInput
        ];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ""));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => {
          if (field) field.disabled = false;
        });
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => {
          if (field) field.disabled = true;
        });
      }

      displayErrorMessage(title, body) {
        if (!this.errorMessage) return;

        this.clearErrorMessage();
        this.errorMessage.hidden = false;

        if (typeof body === "object") {
          Object.entries(body).forEach(([key, value]) => {
            const message = `${value.join(", ")}`;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(
                this.createErrorListItem(message)
              );
            }

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute("aria-invalid", true);
          });
        }
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        li.innerText = message;
        return li;
      }

      clearErrorMessage() {
        if (!this.errorMessage) return;

        this.errorMessage.hidden = true;
        if (this.errorMessageList) this.errorMessageList.innerHTML = "";

        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach(
          (inputElement) => {
            if (!inputElement) return;
            inputElement.setAttribute("aria-invalid", false);
          }
        );
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
          this.fieldsContainer.classList.remove("hidden");
        }
      }
    }
  );
}
